(function (app, ng) {

    app.controller("tourModalController", tourModalController);

    tourModalController.$inject = ["$mdDialog"];
    function tourModalController($mdDialog) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
            });

        $ctrl.close = function ($event) {
            $mdDialog.cancel($event);
        };

        $ctrl.$onInit = function () {

        };
    }

})(window.app, window.angular); //jshint ignore:line